import { useMemo, useState } from 'react';
import sortBy from 'lodash/sortBy';

import SubActivityView from 'approot/activity-builder/components/sub-activity/sub-activity-view';
import ActivitySheet from 'approot/activity-builder/components/shared/sheet/activity-sheet';
import { ClassroomAnswerInstruction } from 'approot/activity-builder/classroom/classroom-answer.style';
import ClassroomAnswerTabs, {
  INDIVIDUAL_VIEW,
  QUESTION_VIEW,
  SUGGESTED_VIEW,
} from 'approot/activity-builder/classroom/classroom-answer-tabs';
import { ComponentResponse } from '../../component.constants';
import { ResponseViewContainer } from '../response-view.style';
import ResponseViewField from '../response-view-field';
import { useResponseBaseHeight } from '../response.hooks';
import TextResponseSuggestedAnswers from 'approot/activity-builder/classroom/text-response/text-response-suggested-answers';
import {
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../../shared/sheet/activity-sheet.style';
import useResponseHasSuggestedAnswer from '../use-response-has-suggested-answer';
import { SampleProps } from '../../sample/activity-sample.constants';

type Props = Omit<ComponentResponse, '__typename'> & {
  onClose: () => void;
} & SampleProps;

const ResponseViewSampleAnswerModal = (props: Props) => {
  const {
    properties,
    subActivityProperties,
    suggestedAnswerProperties,
    id,
    type,
    banner,
    onClose,
  } = props;

  const [tab, setTab] = useState<string>(QUESTION_VIEW);

  const baseHeight = useResponseBaseHeight();

  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );

  const hasSuggestedAnswer = useResponseHasSuggestedAnswer({
    suggestedAnswerProperties,
  });

  return (
    <ActivitySheet
      isVisible
      title="Resonse component"
      hasBackgroundColor={tab === QUESTION_VIEW}
      onClose={() => {
        setTab(INDIVIDUAL_VIEW);
        onClose();
      }}
      tabsContent={
        <ClassroomAnswerTabs
          isPublished
          canClearModelledResponse={false}
          includeIndividualAnswers={false}
          includeClassResponse={false}
          includeSuggestedAnswers={hasSuggestedAnswer}
          tab={tab}
          onSelect={option => setTab(option)}
          componentId={id}
          onCloseActivitySheet={() => {
            setTab(INDIVIDUAL_VIEW);
            onClose();
          }}
        />
      }
      banner={banner}
    >
      <ActivitySheetInnerContent id="content">
        {tab === QUESTION_VIEW &&
          subActivityProperties?.activityComponentId && (
            <ActivitySheetInnerMax>
              <ClassroomAnswerInstruction>
                <SubActivityView
                  withTTSButton
                  componentId={id}
                  componentType={type}
                  subActivityDetails={subActivityProperties}
                >
                  <ResponseViewContainer>
                    {sortedFields.map(field => (
                      <ResponseViewField
                        key={field.itemId}
                        updateAnswer={input => {}}
                        answer={undefined}
                        baseHeight={baseHeight}
                        field={field}
                        componentId={id}
                        activityId={subActivityProperties?.activityComponentId}
                      />
                    ))}
                  </ResponseViewContainer>
                </SubActivityView>
              </ClassroomAnswerInstruction>
            </ActivitySheetInnerMax>
          )}
        {tab === SUGGESTED_VIEW && (
          <ActivitySheetInnerMax>
            <TextResponseSuggestedAnswers component={props} />
          </ActivitySheetInnerMax>
        )}
      </ActivitySheetInnerContent>
    </ActivitySheet>
  );
};

export default ResponseViewSampleAnswerModal;
